import { createModel } from '@rematch/core';
import { FileData } from 'domains/workspaceDetailDomain';
import { RootModel } from 'models';
import { baseReducers, BaseState } from 'models/baseReducers';
import uploadFileService from 'services/uploadService';

interface FileState extends BaseState {
  file?: File[];
}

export const uploadFile = createModel<RootModel>()({
  state: {
    file: [],
  } as FileState,
  reducers: {
    ...baseReducers<FileState>(),
  },
  effects: (dispatch) => {
    // const { uploadFile } = dispatch;
    return {
      async putFile(payload: FormData): Promise<FileData> {
        return await uploadFileService.putFile(payload);
      },
      async postFile(payload: FormData): Promise<FileData> {
        return await uploadFileService.postFile(payload);
      },
      async getPresigned(fileNameList: string[]): Promise<FileData> {
        return await uploadFileService.getPresigned(fileNameList);
      },
    };
  },
});
